import './index.less';

const { ont } = window.utils;

const renderWithdrawRow = (data) => {
  return `
    <tr>
      <td class="column0 column0-wrapper">${data.currency}</td>
      <td class="column">${data.network}</td>
      <td class="column">${data.fee_min}~${data.fee_max}</td>
      <td class="column">${data.quote_increment}</td>
    </tr>
  `;
};
const renderTradeRow = (data) => {
  return `
    <tr>
      <td class="column">${data.currency_pair}</td>
      <td class="column">0</td>
    </tr>
  `;
};

window.addEventListener('DOMContentLoaded', async () => {
  const feesRes = await ont.get('/v2/asset/introduction/fees');
  const { data: withdrawFeesList } = feesRes.data;
  const feesContent = withdrawFeesList
    .map((item) => {
      return renderWithdrawRow(item);
    })
    .join('');
  document.getElementById('withdrawFeesBody').innerHTML = feesContent;

  const tradeRulesRes = await ont.get('/v2/asset/introduction/sellingRules');
  const { data: tradeRules } = tradeRulesRes.data;

  const tradeFeesContent = tradeRules
    .filter((item) => {
      return item.currency_pair.includes('/JPY');
    })
    .map((item) => {
      return renderTradeRow(item);
    })
    .join('');
  document.getElementById('spotFeesBody').innerHTML = tradeFeesContent;
  if (window.location.hash) {
    const element = document.querySelector(
      `[name="${window.location.hash.replace('#', '')}"]`
    );
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});
